import { render, staticRenderFns } from "./pepole.vue?vue&type=template&id=881279ca"
import script from "./pepole.vue?vue&type=script&lang=js"
export * from "./pepole.vue?vue&type=script&lang=js"
import style0 from "./pepole.vue?vue&type=style&index=0&id=881279ca&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports